import { render, staticRenderFns } from "./IndependantForm.vue?vue&type=template&id=4bafdc33"
import script from "./IndependantForm.vue?vue&type=script&lang=js"
export * from "./IndependantForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports